module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAABIElEQVQ4jWP8DwQMVAJM1DIIBFjQBVy8IxkeP3mGoZCDnZ1BR1udISstnsHa0gSrYYzo3lTXt8drOxMTE8OE7gYGdxcs6v6jATU9OzBGB9++f/8/YcpcsJyVo///P3/+YKghOsw4OTgY8rISGZQU5RjevH3PcOvOfUxXE2sYDDAyMkJoLHIYEYAL/Pj5k2HG7MUMd+89ZBAVEWZQVVUi3jB8EZGeEsPAzITpKbLS2dQZCxgePHyMKUFsbILAm7fv/qdml4Hl80rqyI9NEBAWEmRoa6wAs4+dOEu5N6GRCUy8mPFJkmGg9FVR2w5mW5gZYciTFZsCAnwMBdnJhF0mKyOF0xA+Xh4GDzcHhlWLpzMoKshhyGNkdEoAVcuzEWIYAM1tur4+qlY6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchbtb1-2-1.png
// module id = 416
// module chunks = 0